export type VPopoverTheme = 'primary' | 'dark';

const getBackgroundColor = (theme?: VPopoverTheme | undefined) => {
  switch (theme) {
    case 'dark':
      return 'bg-primary-700';
    case 'primary':
    default:
      return 'bg-white';
  }
};

const getTextColor = (theme?: VPopoverTheme | undefined) => {
  switch (theme) {
    case 'dark':
      return 'text-white';
    case 'primary':
    default:
      return 'text-black';
  }
};

const getShadow = (theme?: VPopoverTheme | undefined) => {
  switch (theme) {
    case 'dark':
      return 'shadow-lg';
    case 'primary':
    default:
      return 'shadow-sm';
  }
};

const getBorder = (theme?: VPopoverTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'border border-grey-200';
    default:
      return '';
  }
};

export const getPassthroughStyles = (role: string, theme?: VPopoverTheme) => ({
  root: {
    class: [getTextColor(theme), getBackgroundColor(theme), getShadow(theme)],
    role,
  },
  content: {
    class: [getBorder(theme)],
  },
});
